module.exports = __webpack_public_path__ + "assets/ckan.1ac3da1b.svg";